export default __webpack_public_path__ + "assets/fonts/4adb39d750fd6f874d49ed3f75c943dd.woff";